<script lang="ts" setup>
import type { ClientCustomDashboardInputGraphql } from '~/types/graphql-backend-types/gql-types'
import blurredDashboard from '/assets/blurred_dashboard.png'
import blurredDashboardDark from '/assets/blurred_dashboard_dark.png'

const { t } = useI18n()
const router = useRouter()

const {
  user,
  isAdmin,
  isProducer,
  isRecycler,
} = storeToRefs(useAuthStore())

const dashboardPayload = computed(() => {
  return { dark: isDark.value }
}) as ComputedRef<ClientCustomDashboardInputGraphql>

const { data: iframeDashboardUrl, isPending } = useDashboard(dashboardPayload)

const dashboardCTALabel = computed(() => {
  if (isProducer.value) {
    return user.value.client.hasCollects ? t('dashboard.wp_waiting_for_recycler') : t('dashboard.wp_first_collect')
  }
  else if (isRecycler.value) {
    return t('dashboard.wr_view_collects')
  }
  return t('dashboard.wr_view_collects')
})
</script>

<template>
  <div v-if="isPending" class="flex grow flex-col gap-4">
    <div class="skeleton h-40 w-full" />
    <div class="skeleton h-full w-full" />
  </div>

  <div
    v-else
    id="dashboard"
    class="full-page-container bg-base-200"
  >
    <div v-if="(user.client.hasCollects || isAdmin) && iframeDashboardUrl" class="h-full w-full">
      <iframe
        :src="iframeDashboardUrl"
        frameborder="0"
        width="100%"
        height="100%"
        class="min-h-[1000px]"
        allowtransparency
      />
    </div>
    <div v-else class="h-full w-full flex flex-col gap-4">
      <Card>
        <template #title>
          <div class="flex flex-col">
            <div class="flex gap-2">
              <InfoIcon :size="24" class="text-base-content" />
              <h2>{{ t("global.dashboard_available_after_first_collect_title") }}</h2>
            </div>
            <p class="text-sm font-normal text-base-content">
              {{ t('global.dashboard_available_after_first_collect_desc') }}
            </p>
          </div>

          <div class="ml-auto">
            <EButton
              class="btn-md btn-primary"
              @click="router.push('/collects')"
            >
              {{ dashboardCTALabel }}
            </EButton>
          </div>
        </template>
        <template #content>
          <div class="w-full h-60 pt-4">
            <img
              :src="isDark ? blurredDashboardDark : blurredDashboard"
              alt="dashboard_preview"
              class="rounded-xl w-full h-full object-cover"
            />
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>
